/**
 * @generated SignedSource<<c11e29827ce9919f6e432e4d308a41dd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TransferAppDestinationSelectorFragment_organization$data = {
  readonly id: string;
  readonly imageUrl: string | null | undefined;
  readonly name: string;
  readonly slug: string;
  readonly " $fragmentType": "TransferAppDestinationSelectorFragment_organization";
};
export type TransferAppDestinationSelectorFragment_organization$key = {
  readonly " $data"?: TransferAppDestinationSelectorFragment_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"TransferAppDestinationSelectorFragment_organization">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "TransferAppDestinationSelectorFragment_organization"
};

(node as any).hash = "9d79ea692b3ea2c56f16e270fa2671df";

export default node;
